(function (ng) {
    /// <summary>
    /// Service to return evo trip Traveler objects.
    /// May be expanded in the future to fetch existing travelers
    /// </summary>
    ng.module('evo.Trip.Services').factory('cartService', ['$http', 'CART_SERVICE_BASE', function ($http, CART_SERVICE_BASE) {
        return {
            book: function (booking) {
                return $http.post(CART_SERVICE_BASE + 'addevotripitems', booking).then(function (response) {
                    return response.data;
                });
            }
        };
    }]);
})(angular);